import React from "react";

function SvgHandPackage({
  color = "currentColor",
  width = 20,
  height = 20,
  ...props
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M15 4H9V11H15V4ZM20 4H17V11H20V4ZM14.375 13H8V19H13.55C13.9 19 14.2375 18.9417 14.5625 18.825C14.8875 18.7083 15.1833 18.5333 15.45 18.3L19.6 14.875C19.4667 14.7417 19.3167 14.6417 19.15 14.575C18.9833 14.5083 18.8083 14.4583 18.625 14.425C18.3417 14.375 18.0667 14.3833 17.8 14.45C17.5333 14.5167 17.2833 14.6417 17.05 14.825L14.35 17H10V15H13.65L14.75 14.1C14.8333 14.05 14.8958 13.9833 14.9375 13.9C14.9792 13.8167 15 13.725 15 13.625C15 13.4583 14.9375 13.3125 14.8125 13.1875C14.6875 13.0625 14.5417 13 14.375 13ZM6 13H4V20H6V13ZM7 13V4C7 3.45 7.19583 2.97917 7.5875 2.5875C7.97917 2.19583 8.45 2 9 2H20C20.55 2 21.0208 2.19583 21.4125 2.5875C21.8042 2.97917 22 3.45 22 4V11C22 11.55 21.8042 12.0208 21.4125 12.4125C21.0208 12.8042 20.55 13 20 13H7ZM6 22H4C3.45 22 2.97917 21.8042 2.5875 21.4125C2.19583 21.0208 2 20.55 2 20V13C2 12.45 2.19583 11.9792 2.5875 11.5875C2.97917 11.1958 3.45 11 4 11H14.375C15.7917 11 17.1583 11.2417 18.475 11.725C19.7917 12.2083 20.85 13.025 21.65 14.175L22.325 15.2L16.75 19.85C16.3 20.2333 15.8 20.5208 15.25 20.7125C14.7 20.9042 14.1333 21 13.55 21H7.725C7.54167 21.3 7.3 21.5417 7 21.725C6.7 21.9083 6.36667 22 6 22Z"
        fill={color}
      />
    </svg>
  );
}

export default SvgHandPackage;
